import React from 'react';

/** Claude-style bouncing dots — no spinners, no progress bars. */
export default function AiActivityDots({ className = '' }) {
  return (
    <span className={`aiActivityDots ${className}`.trim()} aria-hidden="true">
      <span className="aiActivityDots__dot" />
      <span className="aiActivityDots__dot" />
      <span className="aiActivityDots__dot" />
    </span>
  );
}
